import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-tile',
  template: `
    <div class="la-tile" [ngClass]="{
    'la-tile--cell': kind === 'cell',
    'la-tile--small': kind === 'small',
    'la-tile--image': kind === 'image'
    }" (click)="clicked.next()">
      <ng-content></ng-content>
    </div>`,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-tile{background:#f7f7f8;border-radius:8px;position:relative}.la-tile:hover{box-shadow:0 0 15px 0 rgba(234,235,237,.74);background:#fff}.la-tile--cell{width:370px;height:88px}.la-tile--cell .la-text--title-2{position:absolute;left:16px;top:23px}.la-tile--cell .la-text--title-3{position:absolute;left:16px;top:47px}.la-tile--cell .la-label{position:absolute;top:0;right:0;border-radius:0 8px 0 5px}.la-tile--small{width:145px;height:145px}.la-tile--small .la-text--title-2{position:absolute;left:16px;bottom:16px}.la-tile--small .la-date-label{position:absolute;top:16px;left:16px}.la-tile--image{width:219px;height:219px;display:flex;justify-content:center;padding:24px}.la-tile--image .la-image__pic{width:auto;height:100%;max-height:115px}.la-tile--image .la-text--title-2{position:absolute;bottom:24px;left:24px}.la-tile--image .la-icon{position:absolute;bottom:24px;right:24px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaTileComponent {
  private _kind: string;
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  get kind(): string {
    return this._kind;
  }

  @Input()
  set kind(kind: string) {
    this._kind = kind;
  }
}
